import React, { useRef, useEffect } from 'react';
import { Alert as MAlert } from '@mui/material';
var Alert = function Alert(props) {
  var duration = props.duration,
    severity = props.severity,
    content = props.content,
    noticeKey = props.noticeKey,
    onClose = props.onClose,
    icon = props.icon;
  var closeTimer = useRef(null);
  var clearCloseTimer = function clearCloseTimer() {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };
  var close = function close(e) {
    if (e) {
      e.stopPropagation();
    }
    clearCloseTimer();
    if (onClose) {
      onClose(noticeKey);
    }
  };
  var startCloseTimer = function startCloseTimer() {
    if (duration) {
      closeTimer.current = window.setTimeout(function () {
        close();
      }, duration * 1000);
    }
  };
  useEffect(function () {
    startCloseTimer();
    return function () {
      return clearCloseTimer();
    };
  }, []);
  var alertConfig = {
    severity: severity,
    sx: {
      mb: '10px'
    }
  };
  // @ts-ignore
  if (icon === false) alertConfig.icon = false;
  return /*#__PURE__*/React.createElement(MAlert, alertConfig, content);
};
export default Alert;